import { render, staticRenderFns } from "./ScreenTitle.vue?vue&type=template&id=3e0c6853&scoped=true"
import script from "./ScreenTitle.vue?vue&type=script&lang=ts"
export * from "./ScreenTitle.vue?vue&type=script&lang=ts"
import style0 from "./ScreenTitle.vue?vue&type=style&index=0&id=3e0c6853&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0c6853",
  null
  
)

export default component.exports